import { useCallback, useState } from "react";

export function useInviteUserDialog() {
  const [openInviteUserDialog, setOpenInviteUserDialog] = useState(false);
  const [openUploadUserCSVDialog, setOpenUploadUserCSVDialog] = useState(false);

  const handleClickOpen = useCallback(() => {
    setOpenInviteUserDialog(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpenInviteUserDialog(false);
  }, []);

  const handleOpenUploadUserCSV = useCallback(() => {
    setOpenInviteUserDialog(false);
    setOpenUploadUserCSVDialog(true);
  }, []);

  const handleCloseUploadUserCSV = useCallback(() => {
    setOpenUploadUserCSVDialog(false);
  }, []);

  return {
    handleClickOpen,
    handleClose,
    handleCloseUploadUserCSV,
    handleOpenUploadUserCSV,
    openInviteUserDialog,
    openUploadUserCSVDialog,
  };
}
